import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import OrderTableColumnsTypeNameMap from "@/scenes/OrderManagement/map/OrderTableColumnsTypeNameMap";
import { SettingOutlined } from "@ant-design/icons";
import React from "react";
import { useCopyOrderInfoClick } from "../../../BottomOperationBar/OtherOperationsButton/hooks/useCopyOrderInfoClick";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { observer } from "mobx-react-lite";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { useModalStore } from "@/hooks/Modal/hooks";
import CopyOrderInfoSettingModal from "../../../dialogs/CopyOrderInfoSettingModal";
import ShopType from "@/enum/ShopType";

interface OriginalIdHeadProps {
    shop?: ShopDTO;
    tab?: OrderTab;
}

const OriginalIdHead: React.FC<OriginalIdHeadProps> = function (props) {
    const { shop, tab } = props;
    const { handleCopyOrderInfoClick } = useCopyOrderInfoClick(shop?.id, tab);
    const orderManagementStore = useOrderManagementStore();
    const modalStore = useModalStore();

    return (
        <th>
            <div>
                <span>
                    {[ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(shop?.type)
                        ? "代发编号"
                        : OrderTableColumnsTypeNameMap[OrderTableColumnsType.ORIGINAL_ID]}
                </span>

                <a
                    href="#"
                    className="ml5"
                    onClick={(e) => {
                        e.preventDefault();

                        const selectedOrders = orderManagementStore.table.selectedOrders;
                        const allOrders = orderManagementStore.table.orders;

                        const targetOrders = selectedOrders?.length ? selectedOrders : allOrders;

                        handleCopyOrderInfoClick(targetOrders);
                    }}
                >
                    复制
                </a>

                <a
                    href="#"
                    className="ml3"
                    style={{ marginTop: "1px", display: "inline-block" }}
                    onClick={(e) => {
                        e.preventDefault();

                        modalStore.openModal(CopyOrderInfoSettingModal);
                    }}
                >
                    <SettingOutlined />
                </a>
            </div>
        </th>
    );
};

export default observer(OriginalIdHead);
